import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar } from 'lucide-react';

interface TimeFilterProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  vertical?: boolean;
}

const TimeFilter: React.FC<TimeFilterProps> = ({ activeFilter, onFilterChange, vertical = false }) => {
  const filters = [
    { id: '1h', label: '1 Hour', icon: Clock },
    { id: '1d', label: '1 Day', icon: Clock },
    { id: '1w', label: '1 Week', icon: Calendar },
    { id: '1m', label: '1 Month', icon: Calendar },
  ];

  if (vertical) {
    return (
      <div className="space-y-2">
        {filters.map((filter) => {
          const Icon = filter.icon;
          const isActive = activeFilter === filter.id;
          
          return (
            <motion.button
              key={filter.id}
              onClick={() => onFilterChange(filter.id)}
              className={`relative w-full px-4 py-3 text-sm font-medium rounded-apple transition-all duration-200 ${
                isActive
                  ? 'bg-traqpack-yellow text-black shadow-sm'
                  : 'bg-traqpack-gray-100 text-traqpack-gray-700 hover:bg-traqpack-gray-200'
              }`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex items-center space-x-3">
                <Icon className="w-4 h-4" />
                <span>{filter.label}</span>
              </div>
            </motion.button>
          );
        })}
        
        {/* Custom Date Range Button */}
        <motion.button
          onClick={() => {
            // TODO: Implement custom date picker
            console.log('Custom date range picker');
          }}
          className="w-full px-4 py-3 text-sm font-medium bg-traqpack-gray-100 text-traqpack-gray-700 hover:bg-traqpack-gray-200 rounded-apple transition-colors duration-200"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <div className="flex items-center space-x-3">
            <Calendar className="w-4 h-4" />
            <span>Custom Range</span>
          </div>
        </motion.button>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-1 bg-traqpack-gray-100 p-1 rounded-apple">
      {filters.map((filter) => {
        const Icon = filter.icon;
        const isActive = activeFilter === filter.id;
        
        return (
          <motion.button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
              isActive
                ? 'text-traqpack-gray-900'
                : 'text-traqpack-gray-600 hover:text-traqpack-gray-900'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {isActive && (
              <motion.div
                layoutId="timeFilterBackground"
                className="absolute inset-0 bg-white rounded-lg shadow-sm"
                initial={false}
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 35,
                }}
              />
            )}
            
            <div className="relative flex items-center space-x-2">
              <Icon className="w-4 h-4" />
              <span>{filter.label}</span>
            </div>
          </motion.button>
        );
      })}
      
      {/* Custom Date Range Button */}
      <motion.button
        onClick={() => {
          // TODO: Implement custom date picker
          console.log('Custom date range picker');
        }}
        className="px-4 py-2 text-sm font-medium text-traqpack-gray-600 hover:text-traqpack-gray-900 rounded-lg transition-colors duration-200"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <div className="flex items-center space-x-2">
          <Calendar className="w-4 h-4" />
          <span>Custom</span>
        </div>
      </motion.button>
    </div>
  );
};

export default TimeFilter;